import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import {
  applyRouterMiddleware,
  Router,
  Route,
  browserHistory,
  IndexRedirect,
  Redirect
} from 'react-router';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import reducers from './reducers';
import promiseMiddleware from 'redux-promise-middleware';
import logger from 'redux-logger';
import { tokenVerificationMiddleware } from './middlewares/tokenVerification';
import { isSessionValid, refreshSession } from './lib/cognitoHelper';
import { authenticateByValidSession } from './actions/userActions';
import { addLocaleData } from 'react-intl';
import esLocaleData from 'react-intl/locale-data/es';
import enLocaleData from 'react-intl/locale-data/en';

addLocaleData([...esLocaleData, ...enLocaleData]);

let App = require('./containers/App');
const rMiddleware = routerMiddleware(browserHistory);

const store = createStore(
  reducers,
  applyMiddleware(
    rMiddleware,
    logger,
    tokenVerificationMiddleware,
    promiseMiddleware()
  )
);

const history = syncHistoryWithStore(browserHistory, store);

function scrollToTop() {
  window.scrollTo(0, 0);
}

/**
 * Applied to the routes that need authentication before accessing.
 * For exmaple all routes under app/
 * If authentication=false, checks if session is valid if it is it refreshes the tokens and then authenticate directly.
 * It redirects to login when, authentication == false, session is invalid, and if session is valid but couldnt refresh tokens.
 * @param store
 */
const requireAuth = store => async (nextState, replace, cb) => {
  const state = store.getState();
  let hasToGoToLogin = false;
  if (!state.authentication || !state.authentication.isAuthenticated) {
    if (await isSessionValid()) {
      const refreshedSession = await refreshSession(); // returns {refreshed:boolean, tokens:{}}
      if (refreshedSession.refreshed) {
        store.dispatch(authenticateByValidSession(refreshedSession.tokens));
      } else {
        hasToGoToLogin = true;
      }
    } else {
      hasToGoToLogin = true;
    }
    hasToGoToLogin = true;
  }

  if (hasToGoToLogin) {
    replace('/login');
  }
  cb();
};

/**
 * Applied to the routes that, if user is already authenticated, makes no sense showing,
 * If authentication=false, checks if session is valid if it is it refreshes the tokens and then authenticate directly.
 * such as /login, /signup
 * @param store
 */
const requireNotAuth = store => async (nextState, replace, cb) => {
  const state = store.getState();
  if (state.authentication && state.authentication.isAuthenticated) {
    replace('/app/dashboard');
    cb();
  } else {
    if (await isSessionValid()) {
      const refreshedSession = await refreshSession(); // returns {refreshed:boolean, tokens:{}}
      if (refreshedSession.refreshed) {
        store.dispatch(authenticateByValidSession(refreshedSession.tokens));
        replace('/app/dashboard');
        cb();
      }
    } else {
      cb();
    }
  }
};

const rootRoute = {
  path: '/',
  component: App,
  childRoutes: [
   
    {
      onEnter: requireNotAuth(store),
      childRoutes: [
        require('./routes/forgotPassword/index'),
        require('./routes/login/index'),
        require('./routes/signUp/index'),
        require('./routes/qrcode/index'),
      ]
    },
    {
      indexRoute: {
        onEnter: (nextState, replace) => replace('/app/dashboard')
      },
      onEnter: requireAuth(store),
      childRoutes: [require('./routes/app/index')]
    },
    {
      childRoutes: [
        require('./routes/404/index'),
        require('./routes/500/index')
      ]
    },
    {
      path: '*',
      indexRoute: { onEnter: (nextState, replace) => replace('/404') },
      status: 404
    }
  ]
};

render(
  <Provider store={store}>
    <Router onUpdate={scrollToTop} history={history} routes={rootRoute} />
  </Provider>,
  document.getElementById('app-container')
);



// WEBPACK FOOTER //
// ./client.js